export default "__VITE_ASSET__BqIzA8HV__"